import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { loadStripe } from '@stripe/stripe-js';
import axiosEvents from '../config/axiosInstanceEvents';

// const stripePromise = loadStripe('pk_live_oYyuovMeNVaQe5SSflWCE8XD00edZonWk9');

function BillingActiveMessage({ user }) {
  const { teamsuser } = useSelector(state => state.teamsAuth);
  const [loaded, setLoaded] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    try {
      const userContext = teamsuser?.user || {};
      const isBillingActive = userContext.isBillingActive;
      const stripeCustomerId = userContext.stripeCustomerId;
      const billingUser = userContext.billingUser;
      const userId = userContext.id;
      const ccUpdate = userContext.ccUpdate;

      // Check if user needs to update payment method (same logic as Slack)
      if (isBillingActive === true && userId?.toString() === billingUser?.toString() && ccUpdate === 'true') {
        setLoaded(true);
        setRedirect(true);

        (async () => {
          try {
            const configT = {
              headers: {
                'Content-Type': 'application/json',
              }
            };

            const body = JSON.stringify({
              customerId: stripeCustomerId,
              returnUrl: window.location.origin // Return to current Teams billing page
            });

            const res = await axiosEvents.post('/api/checkoutSessionNew/billingportal', body, configT);
            const sessionUrl = res.data;
            window.location.href = sessionUrl;
          } catch (error) {
            console.error('Error redirecting to billing portal:', error);
            setRedirect(false);
            setLoaded(true);
          }
        })();
      } else {
        setLoaded(true);
        setRedirect(false);
      }
    } catch (error) {
      console.error('Error in BillingActiveMessage:', error);
      setLoaded(true);
      setRedirect(false);
    }
  }, [teamsuser]);

  if (!loaded) {
    return (
      <div className="billing-dashboard">
        <div className="container mt-5">
          <div className="text-center">
            <div className="loading-spinner" style={{ width: '60px', height: '60px', margin: '2rem auto' }}></div>
            <h2>Loading your subscription details...</h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="billing-dashboard">
      <div className="container mt-5">
        {redirect === false ? (
          <div className="text-center" style={{ 
            minHeight: '80vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            margin: '-2rem -15px',
            padding: '2rem 15px'
          }}>
            <div style={{
              background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
              borderRadius: '24px',
              padding: '4rem 3rem',
              maxWidth: '650px',
              width: '100%',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Subtle background pattern */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 20% 80%, rgba(224, 79, 96, 0.03) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(39, 174, 96, 0.03) 0%, transparent 50%)',
                pointerEvents: 'none'
              }} />

              {/* Success Icon */}
              <div style={{ 
                marginBottom: '2.5rem',
                position: 'relative',
                zIndex: 1
              }}>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)',
                  borderRadius: '50%',
                  marginBottom: '1.5rem',
                  boxShadow: '0 15px 35px rgba(39, 174, 96, 0.3), 0 5px 15px rgba(0, 0, 0, 0.08)',
                  position: 'relative'
                }}>
                  <i className="fa fa-check" style={{ 
                    fontSize: '2.5rem', 
                    color: 'white'
                  }}></i>
                  
                  {/* Pulse animation rings */}
                  <div style={{
                    position: 'absolute',
                    top: '-10px',
                    left: '-10px',
                    right: '-10px',
                    bottom: '-10px',
                    border: '2px solid rgba(39, 174, 96, 0.2)',
                    borderRadius: '50%',
                    animation: 'pulse 2s infinite'
                  }} />
                </div>
              </div>
              
              {/* Main Title */}
              <h1 style={{ 
                color: '#2C3E50', 
                marginBottom: '1.5rem',
                fontSize: '2.5rem',
                fontWeight: '800',
                letterSpacing: '-0.025em',
                lineHeight: '1.2',
                position: 'relative',
                zIndex: 1
              }}>
                You're All Set! 🎉
              </h1>
              
              {/* Subtitle */}
              <p style={{ 
                color: '#6c757d', 
                fontSize: '1.2rem',
                lineHeight: '1.6',
                marginBottom: '3rem',
                fontWeight: '400',
                maxWidth: '480px',
                margin: '0 auto 3rem auto',
                position: 'relative',
                zIndex: 1
              }}>
                Your Ricotta Games on Teams subscription is active and ready to boost your team's engagement with interactive games and trivia.
              </p>

              {/* Support Section */}
              <div style={{
                background: 'linear-gradient(135deg, rgba(224, 79, 96, 0.05) 0%, rgba(224, 79, 96, 0.02) 100%)',
                borderRadius: '20px',
                padding: '2rem',
                border: '1px solid rgba(224, 79, 96, 0.08)',
                position: 'relative',
                zIndex: 1
              }}>
                <h3 style={{ 
                  color: '#2C3E50', 
                  marginBottom: '1rem',
                  fontSize: '1.2rem',
                  fontWeight: '700'
                }}>
                  Need to change or cancel your plan?
                </h3>
                <p style={{ 
                  color: '#6c757d',
                  fontSize: '1rem',
                  marginBottom: '1.5rem',
                  lineHeight: '1.5'
                }}>
                  For billing changes, plan updates, or any questions about your subscription.
                </p>
                
                <a 
                  href="mailto:cheese@ricotta.team" 
                  style={{ 
                    background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                    color: 'white',
                    textDecoration: 'none',
                    padding: '14px 32px',
                    borderRadius: '50px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 25px rgba(224, 79, 96, 0.3)',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 12px 35px rgba(224, 79, 96, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 8px 25px rgba(224, 79, 96, 0.3)';
                  }}
                >
                  <i className="fa fa-envelope" style={{ fontSize: '0.9rem' }}></i>
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center" style={{ 
            minHeight: '80vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            margin: '-2rem -15px',
            padding: '2rem 15px'
          }}>
            <div style={{
              background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
              borderRadius: '24px',
              padding: '4rem 3rem',
              maxWidth: '500px',
              width: '100%',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Animated loading icon */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                  borderRadius: '50%',
                  marginBottom: '1.5rem',
                  boxShadow: '0 15px 35px rgba(224, 79, 96, 0.3)',
                  position: 'relative'
                }}>
                  <div className="loading-spinner" style={{ 
                    width: '30px', 
                    height: '30px',
                    border: '3px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '3px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  
                  {/* Pulse rings */}
                  <div style={{
                    position: 'absolute',
                    top: '-8px',
                    left: '-8px',
                    right: '-8px',
                    bottom: '-8px',
                    border: '2px solid rgba(224, 79, 96, 0.2)',
                    borderRadius: '50%',
                    animation: 'pulse 2s infinite'
                  }} />
                </div>
              </div>
              
              <h2 style={{ 
                color: '#2C3E50', 
                marginBottom: '1rem',
                fontSize: '1.8rem',
                fontWeight: '700',
                letterSpacing: '-0.025em'
              }}>
                Redirecting to Payment Portal
              </h2>
              <p style={{ 
                color: '#6c757d',
                fontSize: '1.1rem',
                lineHeight: '1.6',
                marginBottom: '2rem'
              }}>
                Please wait while we securely redirect you to update your payment method...
              </p>
              
              {/* Progress indicator */}
              <div style={{
                width: '100%',
                height: '4px',
                background: 'rgba(224, 79, 96, 0.1)',
                borderRadius: '2px',
                overflow: 'hidden',
                marginTop: '1rem'
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                  borderRadius: '2px',
                  animation: 'loading-bar 2s ease-in-out infinite'
                }} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BillingActiveMessage;
